import EmptyState from 'components/EmptyState';
import Spinner from 'components/Spinner';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import useSWR from 'swr';

// const brands = [
//   {
//     name: 'Melcom',
//     logo: require('assets/img/MELCOMLOGO.png'), // replace with actual image path or URL
//   },
//   {
//     name: 'Shell',
//     logo: require('assets/img/shelllogo.png'),
//   },
//   {
//     name: 'Goil',
//     logo: require('assets/img/goillogo.png'),
//   },
// ];

const Merchants = () => {

  const [searchParam] = useSearchParams()
  const id = searchParam.get('game')
  const { data, isValidating } = useSWR(`/promos/give-aways/${id}/merchants`)
  return (

    isValidating ?
      <Spinner />

      :
      <div className="gap-5 max-w-4xl p-4 flex flex-row">
        {data?.data?.length ? data?.data?.map((brand) => (
          <div
            key={brand?.id}
            className="border rounded-lg shadow-sm flex flex-col items-center justify-center h-[200px] w-[150px] bg-white hover:shadow-md transition"
          >
            <img
              src={brand?.avatar}
              alt={brand?.name}
              className="w-20 h-20 object-contain mb-2"
            />
            <span className="text-gray-800 font-medium">{brand?.name}</span>
          </div>
        ))
          : <EmptyState title={'No merchants'} />}
      </div>



  );
};

export default Merchants;
